var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function mergeProgressIntoTask(updatePayload, task) {
    return __assign(__assign({}, task), { progress: Object.keys(updatePayload).reduce(function (progress, hashid) {
            var _a;
            var stepUpdate = updatePayload[hashid];
            var stepProgress = progress[hashid] || {};
            /*
                Set procedure incomplete.
                Send:
                {
                  "progress": {
                    "VV8RNT479O": {
                      "set_completed": false,
                    }
                  }
                }
                Result:
                {
                  "progress": {
                    "VV8RNT479O": {
                      "completed": null,
                      "completed_by": null,
                    }
                  }
    
                Set procedure completed
                Send:
                {
                  "progress": {
                    "VV8RNT479O": {
                      "set_completed": "2020-11-20T16:42:30Z",
                    }
                  }
                }
                Result:
                {
                  "progress": {
                    "VV8RNT479O": {
                      "completed": "2020-11-20T16:42:30Z",
                      "completed_by": BasicUserSerializedType
                    }
                  }
                }
                */
            stepProgress = __assign(__assign(__assign({}, stepProgress), getCompletedState(stepUpdate.set_completed)), getChoiceState(stepUpdate.set_choice));
            if (stepUpdate.steps != null && stepUpdate.steps.length > 0) {
                var stepsUpdateMap_1 = arrayToMap(stepUpdate.steps, function (s) { return s.id; });
                stepProgress = __assign(__assign({}, stepProgress), { steps: reformatStepsProgress(task, hashid).map(function (step, index) {
                        var stepUpdate = stepsUpdateMap_1[step.id || index.toString()] || {};
                        /*
                                Send:
                                {
                                  "progress": {
                                    "VV8RNT479O": {
                                      "steps": [
                                        {
                                          "set_completed": false,
                                          "id": "c6b2797a4ad294be74a7f158d8713e51",
                                          "step": 0
                                        }
                                      ]
                                    }
                                  }
                                }
                                Result:
                                {
                                  "progress": {
                                    "VV8RNT479O": {
                                      "steps": [
                                        {
                                          "id": "c6b2797a4ad294be74a7f158d8713e51",
                                          "step": 0,
                                          "completed": null,
                                          "completed_by": null
                                        },
                                      ]
                                    }
                                  }
                                }
          
                                Set step completed
                                Send:
                                {
                                  "progress": {
                                    "VV8RNT479O": {
                                      "steps": [
                                        {
                                          "set_completed": "2020-11-20T18:01:56Z",
                                          "id": "c6b2797a4ad294be74a7f158d8713e51",
                                          "step": 0
                                        }
                                      ]
                                    }
                                  }
                                }
                                Result:
                                {
                                  "progress": {
                                    "VV8RNT479O": {
                                      "steps": [
                                        {
                                          "id": "c6b2797a4ad294be74a7f158d8713e51",
                                          "step": 0,
                                          "completed": "2020-11-20T18:01:56Z",
                                          "completed_by": BasicUserSerializedType
                                        },
                                      ]
                                    }
                                  }
                                }
                                */
                        return __assign(__assign(__assign({}, step), getCompletedState(stepUpdate.set_completed)), getChoiceState(stepUpdate.set_choice));
                    }) });
            }
            return __assign(__assign({}, progress), (_a = {}, _a[hashid] = stepProgress, _a));
        }, __assign({}, task.progress)) });
}
function arrayToMap(array, keyGetter) {
    return array.reduce(function (map, item, index) {
        map[keyGetter(item, index)] = item;
        return map;
    }, {});
}
function reformatStepsProgress(task, hashid) {
    var _a, _b, _c;
    var steps;
    if (((_a = task.assigned_version_content) === null || _a === void 0 ? void 0 : _a.content_type) === 'processversion') {
        var procedure = task.assigned_version_content.content.find(function (i) {
            return i.type === 'processprocedure' && i.id === hashid;
        });
        // assume procedure has no steps if it's deleted
        steps = (procedure === null || procedure === void 0 ? void 0 : procedure.deleted) ? [] : procedure === null || procedure === void 0 ? void 0 : procedure.content;
    }
    else if (((_b = task.assigned_version_content) === null || _b === void 0 ? void 0 : _b.content_type) === 'procedureversion') {
        steps = task.assigned_version_content.content;
    }
    if (steps == null) {
        throw Error('Couldnt read ' + hashid + ' steps');
    }
    var stepsProgressMap = arrayToMap(((_c = task.progress[hashid]) === null || _c === void 0 ? void 0 : _c.steps) || [], function (stepProgress, index) { return stepProgress.id || index.toString(); });
    return steps.map(function (s) { return (__assign({ step: s.n, id: s.id }, (stepsProgressMap[s.id] || {}))); });
}
function getCompletedState(set_completed) {
    if (set_completed === false) {
        return {
            completed: null,
        };
    }
    else if (typeof set_completed === 'string') {
        return {
            completed: set_completed,
        };
    }
    return {};
}
function getChoiceState(set_choice) {
    return set_choice === null || typeof set_choice === 'string'
        ? { set_choice: set_choice }
        : {};
}
